import { DropdownMenu as M } from "radix-ui";
import type { ComponentType, ReactNode, SVGProps } from "react";
import { cn } from "../../lib/cn";

export const Menu = M.Root;
export const MenuTrigger = M.Trigger;

export function MenuContent({
  children,
  align = "end",
  side = "bottom",
  className,
}: {
  children: ReactNode;
  align?: "start" | "center" | "end";
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
}) {
  return (
    <M.Portal>
      <M.Content
        align={align}
        side={side}
        sideOffset={6}
        collisionPadding={8}
        className={cn("z-[80] min-w-48 rounded-lg bg-surface p-1 shadow-pop animate-pop-in focus:outline-none", className)}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </M.Content>
    </M.Portal>
  );
}

export function MenuItem({
  icon: Icon,
  children,
  onSelect,
  danger,
  disabled,
  hint,
}: {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  children: ReactNode;
  onSelect?: () => void;
  danger?: boolean;
  disabled?: boolean;
  hint?: ReactNode;
}) {
  return (
    <M.Item
      disabled={disabled}
      onSelect={onSelect}
      className={cn(
        "flex h-9 cursor-pointer select-none items-center gap-2.5 rounded-md px-2.5 text-sm outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-40",
        danger ? "text-danger data-[highlighted]:bg-danger-soft" : "text-fg data-[highlighted]:bg-surface-2",
      )}
    >
      {Icon && <Icon className={cn("icon size-[18px]", danger ? "text-danger" : "text-fg-2")} aria-hidden />}
      <span className="flex-1 truncate">{children}</span>
      {hint && <span className="text-xs text-fg-3">{hint}</span>}
    </M.Item>
  );
}

export function MenuSeparator() {
  return <M.Separator className="-mx-1 my-1 h-px bg-line" />;
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <M.Label className="px-2.5 pb-1 pt-1.5 text-xs font-medium text-fg-3">{children}</M.Label>;
}
